<template>
  <div>
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <div v-else>
      <h1 class="text-center text-info">List of Students Enrolled</h1>
      <InstitutionUserTable v-if="tableView" :users="listOfUsersEnrolled" />
      <div v-else>
        <div v-if="editType == 'Bulk_Profile'">
          <profile-update @cancelProfile="cancelProfile" :sortByOrder="sortByOrder"
            :institutionUserIds="institutionUsers" :groupInfo="groupInfo" />
        </div>
        <div v-if="editType == 'Profile'">
          <individual-profile-update @cancelProfile="cancelProfile" :sortByOrder="sortByOrder"
            :institutionUserIds="institutionUsers" :groupInfo="groupInfo" />
        </div>
        <div v-if="editType == 'ViewProfile'">
          <view-profile @cancelProfile="cancelProfile" :sortByOrder="sortByOrder"
            :institutionUserId="selectedInstitutionUserId" :groupInfo="groupInfo"
            :enrollmentNo="selectedEnrollmentNo" />
        </div>
        <div v-else-if="editType == 'RollNumber'">
          <roll-number-update @rollNumbersUpdated="rollNumbersUpdated" :listOfUsersEnrolled="listOfUsersEnrolled"
            :selectedSubgroupUsers="selectedSubgroupUsers" :groupInfo="groupInfo" />
        </div>
        <div v-else class="subgroupUserList px-2">
          <!-- Action Buttons -->
          <div class="editOptions d-flex align-items-center flex-wrap py-2"
            style="border: 2px solid #eeeeeb; border-left: none; border-right: none;"
            v-if="listOfUsersEnrolled.length > 0 && editType == 'Users'">
            <b-form-checkbox size="lg" v-model="allUsersSelected" @change="toggleAll" :indeterminate="indeterminate">
              {{ allUsersSelected ? "Un-select All" : "Select All" }}
            </b-form-checkbox>

            <b-button variant="primary" size="sm" @click="subgroupInstitutionProfileUpdate()"
              :disabled="selectedSubgroupUsers.length == 0 || deleteBtn.disabled">
              Profile Edit <i class="fas fa-edit text-white ml-2"></i>
            </b-button>

            <b-button variant="primary" size="sm" @click="subgroupInstitutionProfileBulkUpdate()"
              :disabled="selectedSubgroupUsers.length == 0 || deleteBtn.disabled">
              Profile Bulk Edit <i class="fas fa-edit text-white ml-2"></i>
            </b-button>

            <b-button variant="info" size="sm" @click="openMessageDeliveryModal()">
              Message Delivery Method <i class="fas fa-envelope text-white ml-2"></i>
            </b-button>

            <b-button variant="primary" size="sm" @click="rollNumberUpdate()"
              :disabled="selectedSubgroupUsers.length == 0 || deleteBtn.disabled">
              Roll Number <i class="fas fa-edit text-white ml-2"></i>
            </b-button>

            <b-button variant="primary" size="sm" class="ml-2" @click="openInviteParentsModal()"
              :disabled="selectedSubgroupUsers.length == 0 || deleteBtn.disabled">
              Invite Parents
            </b-button>

            <b-button variant="success" size="sm" class="ml-2" @click="updateStudentsEnrollStatus('active')"
              :disabled="selectedSubgroupUsers.length == 0 || deleteBtn.disabled">
              {{ enableEnrollStatusBtn ? "Activate" : "working..." }}
            </b-button>

            <b-button variant="danger" size="sm" class="ml-2" @click="updateStudentsEnrollStatus('blocked')"
              :disabled="selectedSubgroupUsers.length == 0 || deleteBtn.disabled">
              {{ enableEnrollStatusBtn ? "Deactivate" : "working..." }}
            </b-button>

            <b-button variant="danger" size="sm" v-html="deleteBtn.text" @click="openDeleteModal()"
              :disabled="selectedSubgroupUsers.length == 0 || deleteBtn.disabled" />

            <b-button variant="success" size="sm"
              :disabled="!enableFeeAlertButtons || selectedSubgroupUsers.length == 0"
              @click="$bvModal.show('feeReminder-confirm')">
              {{ enableFeeAlertButtons ? "Send fee reminder" : "Please wait..." }}
            </b-button>

            <b-button variant="success" size="sm" :disabled="exportCsvBtn.disabled || listOfUsersEnrolled.length == 0"
              @click="exportToExcel('xlsx')">
              {{ exportCsvBtn.text }}
            </b-button>
            <div>
              <b-form-select class="ml-3 mt-2" size="sm" v-model="selectedSort">
                <option value="">-- Sort Options --</option>
                <option value="name">Sort by Name</option>
                <option value="invitation">Sort by Invite</option>
              </b-form-select>
            </div>


            <!-- Fee Reminder Modal -->
            <b-modal id="feeReminder-confirm" no-close-on-backdrop no-close-on-keyboard hide-footer hide-header
              centered>
              <h4>Send fee Reminder SMS</h4>
              <p class="my-4">
                WARNING: You are going to send fee due SMS message to all parents
                of selected students.
              </p>
              <b-row>
                <b-col>
                  <b-button variant="danger" size="sm" @click="$bvModal.hide('feeReminder-confirm')">Cancel</b-button>
                </b-col>
                <b-col class="text-right">
                  <b-button variant="success" size="sm" @click="sentFeeRemainder">Send</b-button>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col>Balance SMS Count: {{ smsCount }}</b-col>
              </b-row>
            </b-modal>

            <!-- Invite Parents Modal -->
            <b-modal id="inviteParents-confirm" no-close-on-backdrop hide-footer title="Invite Parents"
              centered>
              <p>Send parent login invitations to the {{ selectedSubgroupUsers.length }} selected student(s).</p>
              <b-form-radio-group v-model="parentInviteMethod"
                :options="[{ text: 'WhatsApp', value: 'whatsapp', disabled: true }, { text: 'Email', value: 'email' }]" />
              <p class="text-muted small mt-2 mb-0">
                Only students whose guardian has
                {{ parentInviteMethod === 'whatsapp' ? 'a WhatsApp number' : 'an email address' }}
                on file will be invited; the rest are skipped.
              </p>
              <p v-if="parentInviteMethod === 'whatsapp'" class="text-danger small mt-2 mb-0">
                Each parent invitation via WhatsApp will cost ₹1.50.
              </p>
              <p v-if="parentInviteMethod === 'whatsapp'" style="font-size: 14px; font-weight: 600"
                class="mt-2 mb-0" :class="smsCount < 1000 ? 'text-danger' : 'text-dark'">
                Balance SMS Count:
                <span>{{ smsCount }}</span>
              </p>
              <b-row class="mt-4">
                <b-col>
                  <b-button variant="danger" size="sm" @click="$bvModal.hide('inviteParents-confirm')">Cancel</b-button>
                </b-col>
                <b-col class="text-right">
                  <b-button variant="success" size="sm" @click="inviteSelectedStudentsParents">Send Invitation</b-button>
                </b-col>
              </b-row>
            </b-modal>
          </div>

            <!-- Message Delivery Method Modal -->
            <b-modal id="messageDeliveryModal" title="Message Delivery Method" size="lg" hide-footer
              no-close-on-backdrop>
              <div class="mb-3 d-flex justify-content-end">
                <b-button variant="outline-primary" size="sm" class="mr-2" @click="selectAllDelivery('sms')">
                  Select All SMS
                </b-button>
                <b-button variant="outline-success" size="sm" @click="selectAllDelivery('whatsapp')">
                  Select All WhatsApp
                </b-button>
              </div>
              <table class="table table-bordered table-sm">
                <thead class="thead-light">
                  <tr>
                    <th>No.</th>
                    <th>Student Name</th>
                    <th class="text-center">SMS</th>
                    <th class="text-center">WhatsApp</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(student, index) in deliveryStudents" :key="student.id">
                    <td>{{ student.roll_number || (index + 1) }}</td>
                    <td>{{ student.first_name }} {{ student.last_name }}</td>
                    <td class="text-center">
                      <b-form-radio v-model="student.message_delivery_method" value="sms"
                        :name="'delivery-' + student.id" />
                    </td>
                    <td class="text-center">
                      <b-form-radio v-model="student.message_delivery_method" value="whatsapp"
                        :name="'delivery-' + student.id" />
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="d-flex justify-content-end mt-3">
                <b-button variant="success" size="sm" class="mr-2" @click="saveMessageDeliveryMethods()"
                  :disabled="deliverySaveBtn.disabled">
                  {{ deliverySaveBtn.text }}
                </b-button>
                <b-button variant="danger" size="sm" @click="$bvModal.hide('messageDeliveryModal')">
                  Cancel
                </b-button>
              </div>
            </b-modal>

          <!-- Table -->
         
          <div class="enrolledUsersTableView mt-2" v-if="editType == 'Users'">
            <div class="table-responsive rounded">
            <table class="table table-striped table-bordered table-sm"
              style="font-size: 5px; font-weight: 500; width: 100%;" ref="subgroupUsers">
              <thead class="thead-dark">
                <tr>
                  <th class="sticky-col first-col"></th>
                  <th class="sticky-col invited-col">
                    <div class="d-flex flex-column align-items-start">
                      <span>Parent Login</span>
                      <b-button size="sm" variant="outline-light" class="py-0 px-1 mt-1"
                        title="Enable all" @click="inviteAllParents()">
                        Enable All
                      </b-button>
                    </div>
                  </th>
                  <th class="sticky-col second-col">
                    {{ studentListOrder === 'enrollment_no' ? 'Enrollment No.' : studentListOrder === 'admission_number' ? 'Admission No.' : studentListOrder === 'register_number' ? 'Register No.' : 'Roll No.' }}
                  </th>
                  <th class="sticky-col third-col">Name</th>
                  <th>Sign-up Status</th>
                  <th>Name (Personal Profile)</th>
                  <th v-if="studentListOrder !== 'admission_number'">Admission No.</th>
                  <th v-if="studentListOrder === 'enrollment_no' || studentListOrder === 'admission_number' || studentListOrder === 'register_number'">Roll No.</th>
                  <th v-if="studentListOrder !== 'enrollment_no'">Enrollment No.</th>
                  <th v-if="studentListOrder !== 'register_number'">Registration No.</th>
                  <th>Gender</th>
                  <th>Phone No.</th>
                  <th>Email</th>
                  <th>Guardian Name</th>
                  <th>Guardian Phone</th>
                  <th>Guardian Email</th>
                  <th>Aadhaar card no</th>
                  <th>Date of Joining</th>
                  <th>Entrance Rank</th>
                  <th>Category Of Admission</th>
                  <th>Religion & Caste</th>
                  <th>Blood Group</th>
                  <th>Reservation Category</th>
                  <th>Communication Address</th>
                  <th>Permanent Address</th>
                  <th>Institution Last Attended(HSE)</th>
                  <th>Code of Institution last attended</th>
                  <th>District of institution last attended</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="listOfUsersEnrolled.length === 0" class="text-danger">
                  <td colspan="100">No Students Found!</td>
                </tr>
                <tr v-else v-for="(student, studentIndex) in listOfUsersEnrolled" :key="studentIndex">
                  <td class="sticky-col first-col">
                    <b-form-checkbox size="sm" v-model="selectedSubgroupUsers" :value="student.id" />
                  </td>
                  <td class="sticky-col invited-col">
                    <b-form-checkbox switch :checked="!!student.parent_invited"
                      :key="`parent-access-${student.institution_user_id}-${parentAccessResetKeys[student.institution_user_id] || 0}`"
                      :disabled="parentAccessBusyId === student.institution_user_id"
                      @change="onParentLoginSwitchChange(student, $event)" />
                  </td>
                  <td class="sticky-col second-col">{{
                    studentListOrder === 'enrollment_no' ? (student.enrollment_no || '-') :
                    studentListOrder === 'admission_number' ? (student.admission_no || '-') :
                    studentListOrder === 'register_number' ? (student.register_no || '-') :
                    (student.roll_number || 'RN')
                  }}</td>
                  <td class="sticky-col third-col">
                    <span class="btn p-0 m-0 text-info font-weight-bolder text-capitalize" style="cursor: pointer;"
                      @click="viewProfile(student.institution_user_id)">
                      {{ student.first_name || "" }} {{ student.last_name || "" }}
                    </span>
                  </td>
                  <td>
                    <b-badge v-if="!student.user_id" pill variant="warning">Pending</b-badge>
                    <b-badge v-else pill variant="success">Completed</b-badge>
                    <b-badge v-if="student.enroll_status !== 'active'" variant="danger"
                      class="ml-2">Deactivated</b-badge>
                    <b-button v-if="!student.user_id" variant="info" size="sm" class="m-1 p-1"
                      @click="resendInvitation(student.institution_user_id)">
                      Resend
                    </b-button>
                  </td>
                  <td class="text-danger">{{ ( student.user_profile ? student.user_profile.first_name : '' ) +' '+ (student.user_profile ? student.user_profile.last_name : '' )}}</td>
                  <td v-if="studentListOrder !== 'admission_number'">{{ student.admission_no || "" }}</td>
                  <td v-if="studentListOrder === 'enrollment_no' || studentListOrder === 'admission_number' || studentListOrder === 'register_number'">{{ student.roll_number || "" }}</td>
                  <td class="text-uppercase" v-if="studentListOrder !== 'enrollment_no'">{{ student.enrollment_no || "" }}</td>
                  <td class="text-uppercase" v-if="studentListOrder !== 'register_number'">{{ student.register_no || "" }}</td>
                  <td class="text-capitalize">{{ student.gender || "-" }}</td>
                  <td>{{ student.mobile || "" }}</td>
                  <td>{{ student.email || "" }}</td>
                  <td>{{ (student.guardians && student.guardians[0]) ? student.guardians[0].name : "" }}</td>
                  <td>{{ (student.guardians && student.guardians[0]) ? student.guardians[0].phone_number : "" }}</td>
                  <td>{{ (student.guardians && student.guardians[0]) ? student.guardians[0].email : "" }}</td>
                  <td>{{ (student.profile) ? student.profile.aadhaar_card_no : "" }}</td>
                  <td>{{ (student.profile && student.profile.date_of_joining) ?
                    formatDate(student.profile.date_of_joining) : "" }}</td>
                  <td>{{ (student.profile) ? student.profile.entrance_rank : "" }}</td>
                  <td>{{ (student.profile && student.profile.category_of_admission) ?
                    student.profile.category_of_admission.toUpperCase() : "" }}</td>
                  <td>
                    {{ (student.profile && student.profile.religion) ? student.profile.religion.toUpperCase() : "" }} -
                    {{ (student.profile && student.profile.caste) ? student.profile.caste.toUpperCase() : "" }}
                  </td>
                  <td>{{ (student.profile && student.profile.blood_group) ? student.profile.blood_group.toUpperCase() :
                    "" }}</td>
                  <td>{{ (student.profile && student.profile.reservation_category) ?
                    student.profile.reservation_category.toUpperCase() : "" }}</td>

                  <!-- Communication Address -->
                  <td>
                    {{
                      (student.profile ? [
                        student.profile.house_name_communication_address,
                        student.profile.town_communication_address,
                        student.profile.pincode_communication_address,
                        student.profile.district_communication_address,
                        student.profile.state_communication_address,
                        student.profile.country_communication_address
                      ].filter(function (a) { return a; }).join(', ') : "")
                    }}
                  </td>

                  <!-- Permanent Address -->
                  <td>
                    {{
                      (student.profile ? [
                        student.profile.house_name_permanent_address,
                        student.profile.town_permanent_address,
                        student.profile.pincode_permanent_address,
                        student.profile.district_permanent_address,
                        student.profile.state_permanent_address,
                        student.profile.country_permanent_address
                      ].filter(function (a) { return a; }).join(', ') : "")
                    }}
                  </td>

                  <td>{{ (student.profile) ? student.profile.last_institution : "" }}</td>
                  <td>{{ (student.profile) ? student.profile.code_of_institution_last_attended : "" }}</td>
                  <td>{{ (student.profile) ? student.profile.district_of_institution_last_attended : "" }}</td>
                </tr>
              </tbody>

            </table>

            <h6 class="mt-3">Removed Students ({{ removedSubgroupUsers.length }})</h6>
            <table class="table table-striped table-bordered table-sm removedStudentsTable"
              style="font-size: 5px; font-weight: 500; width: 100%;">
              <thead class="thead-dark">
                <tr>
                  <th class="sticky-col second-col">
                    {{ studentListOrder === 'enrollment_no' ? 'Enrollment No.' : studentListOrder === 'admission_number' ? 'Admission No.' : studentListOrder === 'register_number' ? 'Register No.' : 'Roll No.' }}
                  </th>
                  <th class="sticky-col third-col">Name</th>
                  <th>Sign-up Status</th>
                  <th>Name (Personal Profile)</th>
                  <th v-if="studentListOrder !== 'admission_number'">Admission No.</th>
                  <th v-if="studentListOrder === 'enrollment_no' || studentListOrder === 'admission_number' || studentListOrder === 'register_number'">Roll No.</th>
                  <th v-if="studentListOrder !== 'enrollment_no'">Enrollment No.</th>
                  <th v-if="studentListOrder !== 'register_number'">Registration No.</th>
                  <th>Gender</th>
                  <th>Phone No.</th>
                  <th>Email</th>
                  <th>Guardian Name</th>
                  <th>Guardian Phone</th>
                  <th>Guardian Email</th>
                  <th>Aadhaar card no</th>
                  <th>Date of Joining</th>
                  <th>Entrance Rank</th>
                  <th>Category Of Admission</th>
                  <th>Religion & Caste</th>
                  <th>Blood Group</th>
                  <th>Reservation Category</th>
                  <th>Communication Address</th>
                  <th>Permanent Address</th>
                  <th>Institution Last Attended(HSE)</th>
                  <th>Code of Institution last attended</th>
                  <th>District of institution last attended</th>
                  <th>Restore</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="removedSubgroupUsers.length === 0" class="text-muted">
                  <td colspan="100">No removed students</td>
                </tr>
                <tr v-else v-for="(student, studentIndex) in removedSubgroupUsers" :key="'removed' + studentIndex">
                  <td class="sticky-col second-col">{{
                    studentListOrder === 'enrollment_no' ? (student.enrollment_no || '-') :
                    studentListOrder === 'admission_number' ? (student.admission_no || '-') :
                    studentListOrder === 'register_number' ? (student.register_no || '-') :
                    (student.roll_number || 'RN')
                  }}</td>
                  <td class="sticky-col third-col text-capitalize">
                    {{ student.first_name || "" }} {{ student.last_name || "" }}
                  </td>
                  <td>
                    <b-badge v-if="!student.user_id" pill variant="warning">Pending</b-badge>
                    <b-badge v-else pill variant="success">Completed</b-badge>
                    <b-badge v-if="student.enroll_status !== 'active'" variant="danger"
                      class="ml-2">Deactivated</b-badge>
                  </td>
                  <td class="text-danger">{{ ( student.user_profile ? student.user_profile.first_name : '' ) +' '+ (student.user_profile ? student.user_profile.last_name : '' )}}</td>
                  <td v-if="studentListOrder !== 'admission_number'">{{ student.admission_no || "" }}</td>
                  <td v-if="studentListOrder === 'enrollment_no' || studentListOrder === 'admission_number' || studentListOrder === 'register_number'">{{ student.roll_number || "" }}</td>
                  <td class="text-uppercase" v-if="studentListOrder !== 'enrollment_no'">{{ student.enrollment_no || "" }}</td>
                  <td class="text-uppercase" v-if="studentListOrder !== 'register_number'">{{ student.register_no || "" }}</td>
                  <td class="text-capitalize">{{ student.gender || "-" }}</td>
                  <td>{{ student.mobile || "" }}</td>
                  <td>{{ student.email || "" }}</td>
                  <td>{{ (student.guardians && student.guardians[0]) ? student.guardians[0].name : "" }}</td>
                  <td>{{ (student.guardians && student.guardians[0]) ? student.guardians[0].phone_number : "" }}</td>
                  <td>{{ (student.guardians && student.guardians[0]) ? student.guardians[0].email : "" }}</td>
                  <td>{{ (student.profile) ? student.profile.aadhaar_card_no : "" }}</td>
                  <td>{{ (student.profile && student.profile.date_of_joining) ?
                    formatDate(student.profile.date_of_joining) : "" }}</td>
                  <td>{{ (student.profile) ? student.profile.entrance_rank : "" }}</td>
                  <td>{{ (student.profile && student.profile.category_of_admission) ?
                    student.profile.category_of_admission.toUpperCase() : "" }}</td>
                  <td>
                    {{ (student.profile && student.profile.religion) ? student.profile.religion.toUpperCase() : "" }} -
                    {{ (student.profile && student.profile.caste) ? student.profile.caste.toUpperCase() : "" }}
                  </td>
                  <td>{{ (student.profile && student.profile.blood_group) ? student.profile.blood_group.toUpperCase() :
                    "" }}</td>
                  <td>{{ (student.profile && student.profile.reservation_category) ?
                    student.profile.reservation_category.toUpperCase() : "" }}</td>
                  <td>
                    {{
                      (student.profile ? [
                        student.profile.house_name_communication_address,
                        student.profile.town_communication_address,
                        student.profile.pincode_communication_address,
                        student.profile.district_communication_address,
                        student.profile.state_communication_address,
                        student.profile.country_communication_address
                      ].filter(function (a) { return a; }).join(', ') : "")
                    }}
                  </td>
                  <td>
                    {{
                      (student.profile ? [
                        student.profile.house_name_permanent_address,
                        student.profile.town_permanent_address,
                        student.profile.pincode_permanent_address,
                        student.profile.district_permanent_address,
                        student.profile.state_permanent_address,
                        student.profile.country_permanent_address
                      ].filter(function (a) { return a; }).join(', ') : "")
                    }}
                  </td>
                  <td>{{ (student.profile) ? student.profile.last_institution : "" }}</td>
                  <td>{{ (student.profile) ? student.profile.code_of_institution_last_attended : "" }}</td>
                  <td>{{ (student.profile) ? student.profile.district_of_institution_last_attended : "" }}</td>
                  <td>
                    <b-button variant="primary" size="sm" @click="restoreSubgroupStudent(student)">Restore</b-button>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal title="Remove Students" v-model="showDeleteModal" centered>
      <p class="text-danger">
        You are going to remove {{ selectedSubgroupUsers.length }} student(s) from this class. They will also be removed
        from the courses of this class, and their data there (eg: attendance, marks, evaluations) will be hidden. You can
        restore them later from 'Removed Students'.
      </p>
      <p>To confirm, type <strong>DELETE</strong> and click Delete.</p>
      <b-form-input v-model="deleteInput" placeholder="Type DELETE to confirm" class="mt-2"></b-form-input>
      <template #modal-footer>
        <b-button variant="secondary" size="sm" @click="showDeleteModal = false">Cancel</b-button>
        <b-button variant="danger" size="sm" :disabled="deleteInput !== 'DELETE'" @click="confirmSubgroupStudentsDelete()">
          Delete
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<style>
.enrolledUsersTableView {
  overflow-x: auto;
  width: 100%;
}

.enrolledUsersTableView table {
  white-space: nowrap;
  table-layout: auto;
}

.enrolledUsersTableView th,
.enrolledUsersTableView td {
  padding: 6px 8px;
  font-size: 13px;
  vertical-align: middle;
}

.subgroupUserList .editOptions button,
.subgroupUserList .editOptions .form-control {
  margin: 2px !important;
}
</style>


<script>
import axios from "axios";
import ProfileUpdate from "./ProfileUpdate.vue";
import IndividualProfileUpdate from "./IndividualProfileUpdate.vue";
import RollNumberUpdate from "./RollNumberUpdate.vue";
import ViewProfile from "./ViewProfile.vue";
import XLSX from "xlsx";
import InstitutionUserTable from "../../../institution_users//InstitutionUserTable.vue";

export default {
  props: ["groupInfo"],
  async created() {
    await this.getEnrolledSubgroupUsers();
    this.smsCount = this.$store.getters.getSmsCount.smsBalance;
  },

  components: {
    profileUpdate: ProfileUpdate,
    rollNumberUpdate: RollNumberUpdate,
    InstitutionUserTable,
    IndividualProfileUpdate,
    ViewProfile
  },
  data() {
    return {
      selectedSort: "",
      selectedInstitutionUserId: "",
      institution_users: [],
      institutionUsersProfiles: [],
      institutionuserGuardians: [],
      enableEnrollStatusBtn: true,
      enableFeeAlertButtons: true,
      fetchData: false,
      listOfUsersEnrolled: [],
      removedSubgroupUsers: [],
      showDeleteModal: false,
      deleteInput: "",
      selectedSubgroupUsers: [],
      institutionUsers: [],
      allUsersSelected: false,
      indeterminate: false,
      editType: "Users",
      deleteBtn: {
        text: `Remove <i class="fas fa-trash text-white ml-2"></i>`,
        disabled: false,
      },
      tableView: false,
      exportCsvBtn: {
        text: "Export to Excel",
        disabled: false,
      },
      sortByOrder: "",
      studentListOrder: "roll_number",
      selectedEnrollmentNo: "",
      smsCount: 0,
      deliveryStudents: [],
      deliverySaveBtn: { text: "Save", disabled: false },
      parentInviteMethod: "email",
      parentAccessBusyId: null,
      // Bumped per-student to force the switch to remount and re-read
      // `checked` when a toggle is rejected without `parent_invited`
      // actually changing - see onParentLoginSwitchChange.
      parentAccessResetKeys: {},
    };
  },
  watch: {
    selectedSort(newValue) {
      if (!newValue) return;
      this.sortBy(newValue);
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
      return new Date(date).toLocaleDateString('en-GB', options); // en-GB for dd/mm/yyyy
    },
    updateStudentsEnrollStatus(status) {
      this.listOfUsersEnrolled.forEach((user) => {
        if (this.selectedSubgroupUsers.includes(user.id))
          this.institution_users.push(user.pivot.institution_user_id);
      });
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        "/institutionusers/enroll_status";
      axios
        .post(url, {
          institution_users: this.institution_users,
          enroll_status: status,
        })
        .then(() => {
          this.$toast.success("Enroll status updated successfully");
          this.selectedSubgroupUsers = [];
          this.institution_users = [];
          this.getEnrolledSubgroupUsers();
        })
        .catch(() => {
          this.$toast.error("Failed to update enroll status, please try again");
        });
      this.enableEnrollStatusBtn = true;
    },
    async viewProfile(institution_user_id) {
      this.selectedInstitutionUserId = institution_user_id;
      const student = this.listOfUsersEnrolled.find(s => s.institution_user_id === institution_user_id);
      this.selectedEnrollmentNo = student ? (student.enrollment_no || '') : '';
      this.editType = 'ViewProfile';

      // console.log("this.groupInfo",this.groupInfo);
      // console.log("institution_user_id",institution_user_id);
      // console.log("this.sortByOrder",this.sortByOrder);
      // // this.institutionUsers = [];
      // // this.institutionUsers.push(institution_user_id);
      // this.$root.subContent.subContentComponent = "ViewProfile";
      // this.$root.subContent.subContentData = {
      //   groupInfo: this.groupInfo,  // Ensure groupInfo is defined elsewhere in your component
      //   institutionUserId: [institution_user_id],
      //   sortByOrder: this.sortByOrder  // Ensure sortByOrder is defined elsewhere in your component
      // };
      // this.$root.subContent.enableMainContent = false;
    },
    async exportToExcel(type, fn, dl) {
      this.exportCsvBtn.text = "Please wait...";
      this.exportCsvBtn.disabled = true;
      var elt = this.$refs.subgroupUsers;
      var wb = await XLSX.utils.table_to_book(elt, { sheet: "Sheet JS" });
      this.exportCsvBtn.text = "Export to Excel";
      this.exportCsvBtn.disabled = false;
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(
          wb,
          fn || this.groupInfo.name + "_users." + (type || "xlsx")
        );
    },
    cancelProfile() {
      this.editType = "Users";
      this.selectedSubgroupUsers = [];
      this.allUsersSelected = false;
      this.institutionUsers = [];
      this.getEnrolledSubgroupUsers();
    },
    async subgroupInstitutionProfileBulkUpdate() {
      this.institutionUsers = [];
      await this.listOfUsersEnrolled.forEach((student) => {
        this.selectedSubgroupUsers.forEach((id) => {
          if (student.id == id) {
            this.institutionUsers.push(student.pivot.institution_user_id);
          }
        });
      });
      this.editType = "Bulk_Profile";
    },
    async subgroupInstitutionProfileUpdate() {
      this.institutionUsers = [];
      await this.listOfUsersEnrolled.forEach((student) => {
        this.selectedSubgroupUsers.forEach((id) => {
          if (student.id == id) {
            this.institutionUsers.push(student.pivot.institution_user_id);
          }
        });
      });
      this.editType = "Profile";
    },
    hasGuardianContact(user) {
      return !!(user.guardians && user.guardians[0] &&
        (user.guardians[0].phone_number || user.guardians[0].email));
    },
    // Method-specific version used for the bulk invite flows: WhatsApp only
    // goes to guardians with a phone number, email only to guardians with an
    // email - having the other contact type doesn't count, unlike
    // hasGuardianContact() above (used for the single-student switch, which
    // isn't tied to a chosen delivery method).
    hasGuardianContactForMethod(user, method) {
      const guardian = user.guardians && user.guardians[0];
      if (!guardian) return false;
      return method === "whatsapp" ? !!guardian.phone_number : !!guardian.email;
    },

    // Used by the "Invite Parents" modal (selected students): creates the
    // parent account where missing and sends the invite over the given
    // method for whichever of the given students' guardians have that
    // method's contact detail - including those already enabled via the
    // switch, who were never messaged. There's no bulk disable - that's only ever done one
    // student at a time (onParentLoginSwitchChange). Students whose guardian lacks
    // that contact detail are silently skipped rather than blocking the
    // whole batch - that error only applies when enabling one specific
    // student via its own switch (onParentLoginSwitchChange).
    async inviteParentsByMethod(users, method, noneMessage) {
      const usersWithContact = users.filter(user => this.hasGuardianContactForMethod(user, method));
      if (!usersWithContact.length) {
        this.$toast.error(noneMessage, { top: "top", duration: 6000 });
        return false;
      }

      const institutionUserIds = usersWithContact.map(u => u.institution_user_id);
      const ok = await this.saveParentLoginAccess(institutionUserIds, true, method);
      if (ok) {
        usersWithContact.forEach(u => { u.parent_invited = true; });
      }
      return ok;
    },

    openInviteParentsModal() {
      this.parentInviteMethod = "email";
      this.$bvModal.show("inviteParents-confirm");
      this.refreshSmsCount();
    },

    async refreshSmsCount() {
      try {
        await this.$store.dispatch("getSmsCountBalance");
        this.smsCount = this.$store.getters.getSmsCount.smsBalance;
      } catch (error) {
        // keep showing the last known balance
      }
    },

    async inviteSelectedStudentsParents() {
      const selectedUsers = this.selectedSubgroupUsers
        .map(id => this.listOfUsersEnrolled.find(user => user.id === id))
        .filter(Boolean);
      const method = this.parentInviteMethod;
      const noneMessage = method === "whatsapp"
        ? "None of the selected students' guardians have a WhatsApp number."
        : "None of the selected students' guardians have an email address.";
      const ok = await this.inviteParentsByMethod(selectedUsers, method, noneMessage);
      if (ok) {
        this.selectedSubgroupUsers = [];
        this.$bvModal.hide("inviteParents-confirm");
        // WhatsApp invites are deducted from the wallet
        if (method === "whatsapp") this.refreshSmsCount();
      }
    },

    // "Enable All" in the Parent Login column: like the switch, it only grants
    // access - no WhatsApp/email invite (that's the Invite Parents modal).
    async inviteAllParents() {
      const usersWithContact = this.listOfUsersEnrolled.filter(user => this.hasGuardianContact(user));
      if (!usersWithContact.length) {
        this.$toast.error("None of the students' guardians have a WhatsApp number or email.", { top: "top", duration: 6000 });
        return;
      }
      const ok = await this.saveParentLoginAccess(usersWithContact.map(u => u.institution_user_id), true, null, false);
      if (ok) {
        usersWithContact.forEach(u => { u.parent_invited = true; });
      }
    },

    // The switch is bound via :checked/@change rather than v-model, so the
    // browser flips it the moment it's clicked, before any of this runs.
    // Whenever we end up NOT changing student.parent_invited to match that
    // click (rejected, cancelled, or the API call fails), the `checked` prop
    // sees no diff and Vue won't touch the DOM, leaving the switch stuck in
    // the wrong visual state - bump its reset key to force a remount instead.
    resetParentLoginSwitch(student) {
      this.$set(this.parentAccessResetKeys, student.institution_user_id,
        (this.parentAccessResetKeys[student.institution_user_id] || 0) + 1);
    },

    async onParentLoginSwitchChange(student, enabled) {
      if (enabled) {
        if (!this.hasGuardianContact(student)) {
          this.$toast.error(
            `Guardian WhatsApp/email not updated for ${student.first_name} ${student.last_name}`,
            { top: "top", duration: 6000 }
          );
          this.resetParentLoginSwitch(student);
          return;
        }
      } else {
        const confirmed = await this.$bvModal.msgBoxConfirm(
          `Disable parent portal access for ${student.first_name} ${student.last_name}'s guardian?`,
          { title: "Disable Parent Access", okTitle: "Disable", cancelTitle: "Cancel", okVariant: "danger", centered: true }
        );
        if (!confirmed) {
          this.resetParentLoginSwitch(student);
          return;
        }
      }

      this.parentAccessBusyId = student.institution_user_id;
      // The switch only grants/revokes access - no invite is sent over
      // WhatsApp/email; that's what the Invite Parents modal is for.
      const ok = await this.saveParentLoginAccess([student.institution_user_id], enabled, null, false);
      if (ok) {
        // false positive: `student` is a stable per-call parameter, not
        // shared mutable state another call could race on between the
        // await and here
        // eslint-disable-next-line require-atomic-updates
        student.parent_invited = enabled;
      } else {
        this.resetParentLoginSwitch(student);
      }
      this.parentAccessBusyId = null;
    },

    async saveParentLoginAccess(institutionUserIds, enabled, method, sendInvite = true) {
      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/guardian-portal-access/toggle`;
        const res = await axios.post(url, {
          institutionUserIds,
          enabled,
          method: method || this.parentInviteMethod,
          send_invite: sendInvite
        });
        const fallback = enabled ? (sendInvite ? "Invited successfully." : "Parent access enabled.") : "Parent access disabled.";
        this.$toast.success(res.data.message || fallback, {
          top: "top",
          duration: 3000
        });
        return true;
      } catch (error) {
        const message = error.response?.data?.message ||
          `Failed to ${enabled ? "enable" : "disable"} parent access.`;
        this.$toast.error(message, { top: "top", duration: 4000 });
        return false;
      }
    },

    async openMessageDeliveryModal() {
      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroup/${this.groupInfo.id}/message-delivery-methods`;
        const response = await axios.get(url);
        this.deliveryStudents = response.data.map(s => ({
          ...s,
          message_delivery_method: s.message_delivery_method || 'sms'
        }));
        this.$bvModal.show('messageDeliveryModal');
      } catch {
        this.$toast.error("Failed to load students", { position: "top", duration: 3000 });
      }
    },

    selectAllDelivery(method) {
      this.deliveryStudents.forEach(s => {
        s.message_delivery_method = method;
      });
    },

    async saveMessageDeliveryMethods() {
      this.deliverySaveBtn = { text: "Saving...", disabled: true };
      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroup/${this.groupInfo.id}/message-delivery-methods`;
        await axios.post(url, {
          students: this.deliveryStudents.map(s => ({
            institution_user_id: s.institution_user_id,
            message_delivery_method: s.message_delivery_method
          }))
        });
        this.$toast.success("Message delivery methods updated", { position: "top", duration: 3000 });
        this.$bvModal.hide('messageDeliveryModal');
      } catch {
        this.$toast.error("Failed to save", { position: "top", duration: 3000 });
      } finally {
        this.deliverySaveBtn = { text: "Save", disabled: false };
      }
    },

    async sentFeeRemainder() {
      this.$bvModal.hide("feeReminder-confirm");
      this.enableFeeAlertButtons = false;
      const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroupusers/studentfeeduealert`;
      await this.$axios
        .post(url, {
          usersubgroup: this.groupInfo.id,
          students: this.selectedSubgroupUsers,
        })
        .then(() => {
          this.$toast.success(
            `Fee due alert successfully sent to selected students.`,
            {
              top: "top",
              duration: 3000,
            }
          );
        })
        .catch(() => {
          this.$toast.error(`Failed to sent Fee due alert`, {
            top: "top",
            duration: 6000,
          });
        });

      this.selectedSubgroupUsers = [];
      this.allUsersSelected = false;

      this.enableFeeAlertButtons = true;
    },
    rollNumbersUpdated() {
      this.editType = "Users";
      this.selectedSubgroupUsers = [];
      this.allUsersSelected = false;
      this.getEnrolledSubgroupUsers();
    },
    rollNumberUpdate() {
      this.editType = "RollNumber";
    },
    toggleAll(checked) {
      let subgroupUsers = [];
      this.listOfUsersEnrolled.forEach((user) => {
        subgroupUsers.push(user.id);
      });
      this.selectedSubgroupUsers = checked ? subgroupUsers.slice() : [];
    },

    async sortBy(order) {
      this.sortByOrder = order;
      this.getEnrolledSubgroupUsers();
    },
    async getEnrolledSubgroupUsers() {
      this.fetchData = true;
      let url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroupusers/profileindex`;
      let params = {
        usersubgroupId: this.groupInfo.id,
        sortby: this.sortByOrder
      };
      await this.$axios
        .post(url, params)
        .then((response) => {
          const users = response.data.users ?? response.data;
          this.studentListOrder = response.data.student_list_order || 'roll_number';
          this.listOfUsersEnrolled = users.filter(
            (students) => {
              return students.pivot.usersubgrouprole_id == 2;
            }
          );
          this.sortedArray();
          this.fetchData = false;
        })
        .catch((error) => {
          this.fetchData = false;
          error;
        });
      await this.getRemovedSubgroupUsers();
    },
    async getRemovedSubgroupUsers() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroup/${this.groupInfo.id}/removedstudents`;
      await this.$axios
        .get(url)
        .then((response) => {
          this.removedSubgroupUsers = response.data;
        })
        .catch(() => {
          this.removedSubgroupUsers = [];
        });
    },
    async restoreSubgroupStudent(student) {
      const name = `${student.first_name || ""} ${student.last_name || ""}`.trim();
      if (!confirm(`Restore ${name}? Their class courses, attendance, marks and other data will be restored too.`)) return;

      const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroupusers/${student.id}/restore`;
      await this.$axios
        .post(url)
        .then(() => {
          this.$toast.success(`${name} restored`, {
            position: "top",
            duration: 3000,
          });
        })
        .catch((error) => {
          const message = error.response && error.response.data && error.response.data.message;
          this.$toast.error(message || "Something went wrong!", {
            position: "top",
            duration: 3000,
          });
        });
      await this.getEnrolledSubgroupUsers();
    },
    sortedArray() {
      // this.listOfUsersEnrolled.sort(function(a, b) {
      //   return (
      //     a.roll_number - b.roll_number ||
      //     a.first_name.localeCompare(b.first_name)
      //   );
      // });
      return;
    },
    openDeleteModal() {
      this.deleteInput = "";
      this.showDeleteModal = true;
    },
    async confirmSubgroupStudentsDelete() {
      if (this.deleteInput !== "DELETE") return;
      this.showDeleteModal = false;
      this.deleteInput = "";
      await this.prepareSubgroupStudentForDelete();
    },
    async prepareSubgroupStudentForDelete() {
      this.deleteBtn.text = `Removing <div class="spinner-grow spinner-grow-sm ml-2"></div>`;
      this.deleteBtn.disabled = true;

      for (const student in this.selectedSubgroupUsers) {
        let studentId = this.selectedSubgroupUsers[student];
        const deleteStudent = await this.deleteEnrolledSubgroupStudent(
          studentId,
          student
        );
        if (deleteStudent == "Completed") {
          this.deleteBtn.text = `Remove <i class="fas fa-trash text-white ml-2"></i>`;
          setTimeout(() => {
            this.deleteBtn.disabled = false;
          }, 3000);
          this.$toast.success("All students removed successfully.", {
            position: "top",
            duration: 3000,
          });
          this.selectedSubgroupUsers = [];
          this.allUsersSelected = false;
          this.getEnrolledSubgroupUsers();
        }
        if (!deleteStudent) {
          this.deleteBtn.text = `Remove <i class="fas fa-trash text-white ml-2"></i>`;
          setTimeout(() => {
            this.deleteBtn.disabled = false;
          }, 3000);
          this.$toast.error("Something went wrong!", {
            position: "top",
            duration: 3000,
          });
          return;
        }
      }
    },
    async deleteEnrolledSubgroupStudent(studentId, studentIndex) {
      let userId = this.$store.getters.getAPIKey.deleteSubGroupUser;
      const url = userId.replace("usersubgroup_user_id", studentId);
      let status = null;
      await this.$axios
        .delete(url)
        .then((response) => {
          response;
          if (studentIndex == this.selectedSubgroupUsers.length - 1) {
            status = "Completed";
          } else {
            status = "Deleting";
          }
        })
        .catch((error) => {
          error;
          status = false;
        });
      return status;
    },

    async resendInvitation(InstitutionUserId) {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/institutionusers/${InstitutionUserId}/invitation/resent`;
      this.$axios
        .get(url)
        .then(() => {
          this.$toast.success(`Enrollment code sent successfully`, {
            top: "top",
            duration: 3000,
          });
        })
        .catch(() => {
          this.$toast.error(`Failed to sent enrollment code`, {
            top: "top",
            duration: 3000,
          });
        });
    },
  },
};
</script>

<style>
.subgroupUserList .editOptions button {
  margin-left: 10px;
}

.subgroupUserList i {
  font-size: 12px !important;
}

/* make table scrollable */
.enrolledUsersTableView {
  overflow-x: auto;
  position: relative;
}

/* sticky columns */
.sticky-col {
  position: sticky;
  background: #fff; /* so it doesn’t overlap with striped bg */
  z-index: 2;
}

.first-col {
  left: 0;
  z-index: 3; /* keep above others */
  min-width: 40px;
}

.invited-col {
  left: 40px; /* equal to first-col width */
  min-width: 100px; /* just wide enough for the stacked label/button */
}

.second-col {
  left: 140px; /* first-col + invited-col widths */
  min-width: 80px;
}

.third-col {
  left: 220px; /* first-col + invited-col + second-col widths */
  min-width: 150px;
}

/* removed students table has no checkbox column, so sticky columns start at 0 */
.removedStudentsTable .second-col {
  left: 0;
}

.removedStudentsTable .third-col {
  left: 80px; /* second-col width */
}

/* thead th {
  position: sticky;
  top: 0;
  z-index: 4;
} */

</style>
